"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _InfoCircleLine = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/suggest/InfoCircleLine.svg"));
var _InfoCircleFill = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/suggest/InfoCircleFill.svg"));
var _HelpCircleLine = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/suggest/HelpCircleLine.svg"));
var _HelpCircleFill = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/suggest/HelpCircleFill.svg"));
var _ahooks = require("ahooks");
require("animate.css");
var _antd = require("antd");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _defineType = require("../_util/defineType");
var _utils = require("../_util/utils");
var _icon = _interopRequireDefault(require("../icon"));
var _space = _interopRequireDefault(require("../space"));
var _information = _interopRequireDefault(require("./information"));
var _interface = require("./interface");
var _jsxRuntime = require("react/jsx-runtime");
const Tooltip = props => {
  const {
    size = 's',
    maxWidth = 400,
    overlay,
    title,
    animate,
    mouseLeaveDelay = 0.3,
    overlayClassName,
    overlayStyle,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-tooltip");
  const content = (0, _ahooks.useCreation)(() => {
    if ((0, _interface.isTooltipInfomationTitle)(title)) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_information.default, {
        config: title,
        prefixClass: baseClassName
      });
    }
    return undefined;
  }, [title]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Tooltip, {
    ...restProps,
    overlay: content !== null && content !== void 0 ? content : overlay,
    title: content ? undefined : title,
    mouseLeaveDelay: mouseLeaveDelay,
    overlayClassName: (0, _classnames.default)(baseClassName, overlayClassName, "".concat(baseClassName, "-").concat(size), animate),
    overlayStyle: {
      ...overlayStyle,
      maxWidth
    }
  });
};
const DescIconTooltip = _ref => {
  let {
    children,
    icon,
    iconSize,
    iconClassName,
    iconStyle,
    className,
    style,
    title,
    block,
    itemSpace = 4,
    ...tooltipProps
  } = _ref;
  const attrs = (0, _utils.pickDomAttrs)(tooltipProps);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_space.default, {
    ...attrs.data,
    size: itemSpace,
    block: block,
    className: className,
    style: style,
    children: [!(0, _defineType.isNone)(children) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: children
    }), !(0, _defineType.isNone)(title) && /*#__PURE__*/(0, _jsxRuntime.jsx)(Tooltip, {
      title: title,
      ...tooltipProps,
      children: /*#__PURE__*/_react.default.cloneElement(icon, {
        className: (0, _classnames.default)('desc-tooltip-icon', iconClassName),
        style: {
          fontSize: iconSize ? "".concat(iconSize, "px") : undefined,
          ...iconStyle
        }
      })
    })]
  });
};
Tooltip.Help = _ref2 => {
  let {
    iconType,
    ...restProps
  } = _ref2;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DescIconTooltip, {
    ...restProps,
    icon: iconType === 'filled' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
      type: "suggest/HelpCircleFill"
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
      type: "suggest/HelpCircleLine"
    })
  });
};
Tooltip.Info = _ref3 => {
  let {
    iconType,
    ...restProps
  } = _ref3;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DescIconTooltip, {
    ...restProps,
    icon: iconType === 'filled' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
      type: "suggest/InfoCircleFill"
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
      type: "suggest/InfoCircleLine"
    })
  });
};
var _default = exports.default = Tooltip;